import React from 'react'
import { Typography } from '@mui/material'
import Box from '@mui/material/Box'

import { PrettoSliderDark } from '#/widgets/filters-gpt/ui/pretto-slider'

import styles from './slider.module.scss'

export const Slider = ({
	value,
	title,
	onChange,
	min,
	max,
	step,
	onChangeCommitted,
}: {
	value: number | number[] | undefined
	title: string
	onChange: (event: Event, value: number | number[], activeThumb: number) => void
	min: number
	max: number
	step: number
	onChangeCommitted?: () => void
}) => {
	return (
		<Box sx={{ marginTop: 0.5 }}>
			<Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
				<Typography className='title-main-gray'>{title}</Typography>
				<Typography
					sx={{
						color: '#8280FF',
						fontSize: '15px',
						fontWeight: '600',
						marginBottom: 0.5,
						marginLeft: 1,
					}}
				>
					{value}
				</Typography>
			</Box>

			<Box sx={{ px: '8px' }}>
				<PrettoSliderDark
					onChangeCommitted={onChangeCommitted}
					className={styles.sliderFullWidth}
					value={value}
					onChange={onChange}
					max={max}
					min={min}
					step={step}
					aria-label='pretto slider'
				/>
			</Box>
		</Box>
	)
}
